/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, Media, Button, Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input, Spinner,
} from 'reactstrap'
import Files from 'react-files'
import DatePicker from 'react-datepicker'
import Select from '../../../components/Template/Input/Select'
import DataTable from '../../../components/Template/Table/DataTable'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { notifyError } from '../../../utils/notify'
import { getWalletResume, getFullStatement, getRubrics, getSubRubrics, addExpense } from '../../../store/ducks/wallet'

class WalletResume extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addExpenseModalIsOpen: false,
      rubric: '',
      rubricInputError: '',
      subRubric: '',
      subRubricInputError: '',
      value: '',
      valueInputError: '',
      description: '',
      descriptionInputError: '',
      files: [],
      filesInputError: '',
      date: '',
      dateInputError: '',
    }

    this.files = React.createRef()
  }

  componentDidMount() {
    const { getWalletResume, getFullStatement, getRubrics } = this.props

    getWalletResume()
    getFullStatement()
    getRubrics()
  }

  componentDidUpdate(prevProps) {
    const { getWalletResume, getFullStatement } = this.props
    const { addExpenseIsLoading, addExpenseSuccess } = this.props.wallet

    if (
      prevProps.wallet.addExpenseIsLoading !== addExpenseIsLoading
      && !addExpenseIsLoading
      && addExpenseSuccess
    ) {
      this.setState({ addExpenseModalIsOpen: false })
      getWalletResume()
      getFullStatement()
    }

    return true
  }

  toggleModal = () => {
    const { addExpenseIsLoading } = this.props.wallet

    if (addExpenseIsLoading) {
      return null
    }

    this.setState(prevState => ({
      addExpenseModalIsOpen: !prevState.addExpenseModalIsOpen,
    }))

    return null
  }

  handleAddExpenseSubmit = () => {
    const { addExpense } = this.props
    const { rubric, subRubric, value, description, files, date } = this.state
    const { fullStatement } = this.props.wallet

    if (!rubric) this.setState({ rubricInputError: 'Campo obrigatório.' })
    if (!subRubric) this.setState({ subRubricInputError: 'Campo obrigatório.' })
    if (!date) this.setState({ dateInputError: 'Campo obrigatório.' })
    if (!value) this.setState({ valueInputError: 'Campo obrigatório.' })
    if (!description) this.setState({ descriptionInputError: 'Campo obrigatório.' })
    if (!files || files.length <= 0) this.setState({ filesInputError: 'Adicione ao menos um anexo.' })

    if (
      rubric && subRubric && value && description && date && files
      && files.length > 0 && fullStatement && fullStatement.length > 0 && fullStatement[0].conta_id
    ) {
      addExpense({
        id: fullStatement[0].conta_id,
        rubric,
        subRubric,
        date,
        value,
        description,
        files,
      })
    }

    return null
  }

  render() {
    const { getSubRubrics } = this.props

    const {
      walletResume, getWalletResumeIsLoading,
      fullStatement, getFullStatementIsLoading,
      rubrics, getRubricsIsLoading,
      subRubrics, getSubRubricsIsLoading,
      addExpenseIsLoading,
    } = this.props.wallet

    const {
      addExpenseModalIsOpen, rubric, rubricInputError, value, valueInputError,
      description, descriptionInputError, files, filesInputError, date, dateInputError,
      subRubric, subRubricInputError,
    } = this.state

    if (getWalletResumeIsLoading || getFullStatementIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (walletResume && fullStatement) {
      return (
        <div className="page-content">
          <Modal
            centered
            isOpen={addExpenseModalIsOpen}
            toggle={() => this.toggleModal()}
          >
            <ModalHeader toggle={() => this.toggleModal()}>
              Adicionar despesa
            </ModalHeader>
            <ModalBody>
              <FormGroup className="select2-container">
                <Label>Rubrica</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecionar..."
                  value={{
                    label: rubric.label,
                    value: rubric.value,
                  }}
                  options={rubrics || []}
                  isDisabled={getRubricsIsLoading}
                  isLoading={getRubricsIsLoading}
                  onChange={rubric => {
                    getSubRubrics(rubric.value)
                    this.setState({
                      rubric,
                      rubricInputError: '',
                      subRubric: '',
                      subRubricInputError: '',
                    })
                  }}
                />
                {rubricInputError && <span style={{ color: 'red' }}>{rubricInputError}</span>}
              </FormGroup>
              <FormGroup className="select2-container">
                <Label>Sub-rubrica</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecionar..."
                  value={{
                    label: subRubric.label,
                    value: subRubric.value,
                  }}
                  options={subRubrics || []}
                  isDisabled={!rubrics || getSubRubricsIsLoading}
                  isLoading={getSubRubricsIsLoading}
                  onChange={subRubric => {
                    getSubRubrics(subRubric.value)
                    this.setState({
                      subRubric,
                      subRubricInputError: '',
                    })
                  }}
                />
                {subRubricInputError && <span style={{ color: 'red' }}>{subRubricInputError}</span>}
              </FormGroup>
              <FormGroup>
                <Label>Data</Label>
                <DatePicker
                  locale="pt-BR"
                  className="form-control"
                  selected={date}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  onChange={date => this.setState({
                    date,
                    dateInputError: '',
                  })}
                />
                {
                  dateInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {dateInputError}
                    </span>
                  )
                }
              </FormGroup>
              <FormGroup>
                <Label>Valor</Label>
                <MaskedInput
                  unmask
                  inputRef={el => this.input = el}
                  mask="R$ num"
                  lazy={false}
                  value={value}
                  onAccept={value => this.setState({ value, valueInputError: '' })}
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // digits after point 0 for integers
                      signed: false, // disallow negative
                      thousandsSeparator: '.', // any single char
                      padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                      normalizeZeros: false, // appends or removes zeros at ends
                      radix: ',', // fractional delimiter
                      min: 0,
                      max: 1000000000,
                    },
                  }}
                />
                {
                  valueInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {valueInputError}
                    </span>
                  )
                }
              </FormGroup>
              <FormGroup>
                <Label>Descrição</Label>
                <Input
                  className="form-control"
                  type="text"
                  value={description}
                  onChange={e => this.setState({
                    description: e.target.value,
                    descriptionInputError: '',
                  })}
                />
                {
                  descriptionInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {descriptionInputError}
                    </span>
                  )
                }
              </FormGroup>
              <Row>
                <Col>
                  <Label>Anexos</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    outline
                    color="primary"
                    type="button"
                    className="mb-3 mt-1"
                    size="sm"
                  >
                    <Files
                      multiple
                      clickable
                      ref={this.files}
                      onChange={files => {
                        this.setState({ files, filesInputError: '' })
                      }}
                      onError={(error) => notifyError(error.message)}
                      accepts={['image/png', 'image/jpg', 'image/jpeg', '.pdf']}
                      maxFiles={3}
                      maxFileSize={10000000}
                      minFileSize={1}
                    >
                      <i className="ri-attachment-2 align-middle mr-2" />
                      <span className="align-middle">Adicionar arquivos</span>
                    </Files>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  {files && files.length > 0 && (
                    <div className="files-list">
                      <ul>
                        {files.map((file) => (
                          <li className="files-list-item" key={file.id}>
                            <div className="files-list-item-preview">
                              {file.preview.type === 'image'
                                ? <img className="files-list-item-preview-image" alt="Prévia de arquivo" src={file.preview.url} />
                                : <div className="files-list-item-preview-extension">{file.extension}</div>}
                            </div>
                            <div className="files-list-item-content">
                              <div className="files-list-item-content-item files-list-item-content-item-1">{file.name}</div>
                              <div className="files-list-item-content-item files-list-item-content-item-2">{file.sizeReadable}</div>
                            </div>
                            <div
                              id={file.id}
                              className="files-list-item-remove"
                              onClick={() => this.files.current.removeFile(file)}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {
                    filesInputError
                    && (
                      <span style={{ color: 'red' }}>
                        {filesInputError}
                      </span>
                    )
                  }
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={() => this.toggleModal()}
                color="light"
                className="waves-effect"
                disabled={addExpenseIsLoading}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={() => this.handleAddExpenseSubmit()}
                disabled={addExpenseIsLoading}
              >
                Adicionar
                {addExpenseIsLoading && (
                  <Spinner size="sm" className="ml-2" />
                )}
              </Button>
            </ModalFooter>
          </Modal>

          <Container fluid>

            <Breadcrumbs
              title="Carteira"
              breadcrumbItems={[]}
            />

            <Row className="mb-3">
              <Col>
                <h4>
                  Resumo
                </h4>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Entradas</p>
                        <h5 className="mb-0">
                          R$
                          {' '}
                          {walletResume.entradas.toFixed(2).replace('.', ',')}
                        </h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Saídas</p>
                        <h5 className="mb-0">
                          R$
                          {' '}
                          {walletResume.saidas.toFixed(2).replace('.', ',')}
                        </h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <Media>
                      <Media body className="overflow-hidden">
                        <p className="text-truncate font-size-14 mb-2">Diferença</p>
                        <h5 className="mb-0">
                          R$
                          {' '}
                          {walletResume.diferenca.toFixed(2).replace('.', ',')}
                        </h5>
                      </Media>
                    </Media>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="mb-3 mt-1">
              <Col>
                <h4>
                  Extrato
                </h4>
              </Col>
              <Col style={{ textAlign: 'right' }}>
                {fullStatement && fullStatement.length > 0 && fullStatement[0].conta_id && (
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => this.toggleModal()}
                  >
                    Adicionar despesa
                  </Button>
                )}
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <DataTable
                      sortable={false}
                      data={{
                        columns: [
                          {
                            label: 'ID',
                            field: 'mov_id',
                          },
                          {
                            label: 'Data',
                            field: 'mov_dtQuit',
                          },
                          {
                            label: 'Rubrica',
                            field: 'rubrica_nome',
                          },
                          {
                            label: 'Descrição',
                            field: 'mov_desc',
                          },
                          {
                            label: 'Valor',
                            field: 'mov_vlr',
                          },
                        ],
                        rows: fullStatement.map(item => ({
                          ...item,
                          mov_vlr: `${Number(item.mov_vlr) < 0 ? '-' : ''}R$ ${Math.abs(Number(item.mov_vlr).toFixed(2)).toString().replace('.', ',')}`,
                        })),
                      }}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ wallet: state.wallet })
const mapDispatchToProps = dispatch => bindActionCreators({
  getWalletResume,
  getFullStatement,
  getRubrics,
  addExpense,
  getSubRubrics,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(WalletResume)
